import { useMasterData } from "@/hooks";
import {
  Label,
  SingleSelectDropdown,
} from "@monsterindia/global-ui-components";
import React, { memo } from "react";
import { Controller } from "react-hook-form";

import { DropdownOptionType, SingleDropDownControllerProps } from "../types";

const SingleDropDownController = ({
  name,
  type = "",
  label,
  options = [],
  control,
  onSelect,
  placeholder,
  errorMessage,
  isDisabled = false,
  isRequired = false,
  isSearchable,
  isLoading,
  isLabelHidden = false,
}: SingleDropDownControllerProps<any>) => {
  const {
    masterData,
    getMasterData,
    isLoading: isMasterDataLoading,
  } = useMasterData();
  const loading = isLoading ?? isMasterDataLoading;

  const controllerHTML = (
    <Controller
      name={name}
      control={control}
      rules={isRequired ? { required: "This field is required" } : undefined}
      render={({ field }) => {
        return (
          <SingleSelectDropdown
            {...field}
            id={name}
            width="w-full"
            options={options.length ? options : (masterData ?? [])}
            className="w-full"
            loadingText={loading ? "Loading..." : "No options available"}
            placeholder={placeholder}
            {...(!options.length && {
              onChangeHandler: async (inputText: string) =>
                getMasterData(type, inputText),
            })}
            isSearchable={isSearchable ?? false}
            selectedValue={field.value ?? null}
            handleDropdownSelect={(selected: DropdownOptionType) => {
              field.onChange(selected);
              onSelect(selected);
            }}
            disabled={isDisabled}
            errorText={errorMessage}
          />
        );
      }}
    />
  );

  return (
    <>
      {isLabelHidden ? (
        <>{controllerHTML}</>
      ) : (
        <Label
          labelText={label}
          isRequired={isRequired}
          className="w-full text-sm"
        >
          {controllerHTML}
        </Label>
      )}
    </>
  );
};

export default memo(SingleDropDownController);
